module.exports = __webpack_public_path__ + "img/s8.603b84d2.png";